import Icon from '@mui/icons-material/Business';

import { ListTaxonomies } from './ListTaxonomies';

export const TaxonomiesResourceConfig = {
  list: ListTaxonomies,
  icon: Icon,
  name: 'taxonomies',
};
